<template>
  <div>

    <breadcrumbs />

    <loading :active.sync="isLoading"></loading>

    <div class="content-i">
      <div class="content-box">
        <div class="row pt-4">
          <div class="col-sm-12">
            <!--START - User List -->
            <div class="element-wrapper">
              <h6 class="element-header capitalize">
                {{ t.navigation.sport }}
              </h6>
              <div class="element-box-tp">
                  <table class="table table-bordered table-lg table-v2 table-striped mt-3">
                    <thead>
                      <th>Name</th>
                      <th>Alias</th>
                      <th>Market Groups</th>
                      <th>Active</th>
                    </thead>
                    <tbody>
                    <tr v-for="sport in list">
                      <td class="w-50">{{ sport.nameLn }}</td>
                      <td class="w-50"><input class="form-control" type="text"/></td>
                      <td @click="selectSport(sport)">
                        <router-link :to="{name: 'sports', params: {id: sport.id}}" class="btn">
                          <i class="os-icon os-icon-grid-circles"></i>
                        </router-link>
                      </td>
                      <td><input type="checkbox" v-model="sport.isActive" /></td>
                    </tr>
                    </tbody>
                  </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <sweet-modal ref="umodal">

        <sweet-modal-tab title="PRE MATCH" id="tab1">
          <loading :active.sync="isLoading"></loading>
          <div class="row">
            <div class="col-12">
              <div class="alert" v-if="status >= 200">
								<span v-if="status == 401">
									{{ t.error.access_denied_content }}
								</span>
                <span v-if="status == 404">
									{{ t.error.notfound_content_list }}
								</span>
                <span v-if="status == 200">
									{{ t.processing.success }}
								</span>
              </div>
            </div>
            <div class="col-6">

              <div class="element-wrapper">
                <h6 class="element-header capitalize text-left">
                  Current Groups
                  <a href="#" @click="saveSportMarketGroup" class="btn btn-danger pull-right">
                    <i class="os-icon os-icon-save"></i>
                  </a>
                </h6>
                <div class="element-box-tp">
                  <table class="table table-bordered table-lg table-v2 table-striped" v-if="selectedSport">
                    <draggable v-model="selectedSport.preMarketGroup" @end="preMoved" :element="'tbody'">
                      <tr v-for="(group, k) in selectedSport.preMarketGroup">
                        <td>
                          {{ getMarketGroup(group).n }} ({{ getMarketGroup(group).id }})
                        </td>
                        <td @click="removeGroup(group)">
                          <i class="os-icon os-icon-ui-23"></i>
                        </td>
                      </tr>
                    </draggable>
                  </table>
                </div>
              </div>

            </div>
            <div class="col-6">
              <div class="element-wrapper">
                <h6 class="element-header capitalize text-left">
                  Group List
                </h6>
                <div class="element-box-tp">
                  <table class="table table-bordered table-lg table-v2 table-striped">
                    <tbody>
                    <tr v-for="group in marketGroups">
                      <td>
                        {{ group.n }} ({{ group.id }})
                      </td>
                      <td @click="addGroup(group)">
                        <i class="os-icon os-icon-ui-22"></i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </sweet-modal-tab>

        <sweet-modal-tab title="LIVE MATCH" id="tab2">
          <loading :active.sync="isLoading"></loading>
          <div class="row">
            <div class="col-12">
              <div class="alert" v-if="status >= 200">
								<span v-if="status == 401">
									{{ t.error.access_denied_content }}
								</span>
                <span v-if="status == 404">
									{{ t.error.notfound_content_list }}
								</span>
                <span v-if="status == 200">
									{{ t.processing.success }}
								</span>
              </div>
            </div>
            <div class="col-6">
              <div class="element-wrapper">
                <h6 class="element-header capitalize text-left">
                  Current Groups
                  <a href="#" @click="saveSportMarketGroup" class="btn btn-danger pull-right">
                    <i class="os-icon os-icon-save"></i>
                  </a>
                </h6>
                <div class="element-box-tp">
                  <table class="table table-bordered table-lg table-v2 table-striped" v-if="selectedSport">
                    <draggable v-model="selectedSport.liveMarketGroup" @end="preMoved" :element="'tbody'">
                      <tr v-for="(group, k) in selectedSport.liveMarketGroup">
                        <td>
                          {{ getMarketGroup(group).n }} ({{ getMarketGroup(group).id }})
                        </td>
                        <td @click="removeGroup(group, 'live')">
                          <i class="os-icon os-icon-ui-23"></i>
                        </td>
                      </tr>
                    </draggable>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-6">

              <div class="element-wrapper">
                <h6 class="element-header capitalize text-left">
                  Group List
                </h6>
                <div class="element-box-tp">
                  <table class="table table-bordered table-lg table-v2 table-striped">
                    <tbody>
                    <tr v-for="group in marketGroups">
                      <td>
                        {{ group.n }} ({{ group.id }})
                      </td>
                      <td @click="addGroup(group, 'live')">
                        <i class="os-icon os-icon-ui-22"></i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </sweet-modal-tab>


      </sweet-modal>

      <!--------------------
START - Sidebar
-------------------->
      <div class="content-panel compact">
        <div class="content-panel-close" v-on:click="controlPanel()">
          <i class="os-icon os-icon-close"></i>
        </div>
        <div class="element-wrapper">
          <div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
            <span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
          </div>
          <h6 class="element-header" v-b-toggle.filter variant="primary">
            {{ t.filter.title }}
          </h6>
          <div class="element-box-tp">
            <b-collapse id="filter" class="mt-2">

            </b-collapse>
          </div>
        </div>

      </div>
      <!--------------------
      END - Sidebar
      -------------------->
    </div>
  </div>
</template>

<script>

  import draggable from 'vuedraggable'
  import Feed from '@/mixins/feed.js'

  export default {
    name: 'Sports',
    mixins: [Feed],
    components: {draggable},
    data () {
      return {
        status: 0,
        t: this.$root.t,
        isLoading: true,
        list: null,
        marketGroups: null,
        selectedSport: null,
        tempCurrentPre: []
      }
    },
    watch: {
      'marketGroups' () {
      }
    },
    mounted () {
      this.fetchAllGroups();
      this.fetchSportList();
    },
    methods: {
      selectSport(sport) {
        this.selectedSport = sport;
        this.$refs.umodal.open();
      },
      fetchSportList() {
          this.fetchSports().then(response => {
            this.isLoading = false;
            this.list = response.body.result.sport;
          });
      },
      fetchAllGroups() {
        this.fetchSportMarketList().then(response => {
          this.marketGroups = response.body;
        })
      },
      saveSportMarketGroup() {
        this.isLoading = true;
        this.saveSportMarketList(this.selectedSport).then(response => {
            this.status = response.status;
            this.isLoading = false;

            setTimeout( () => {
              this.status = 0;
            }, 1500);
        })
      },
      getMarketGroup(g) {

        return this.findByKey(this.marketGroups, 'id', g);
      },
      addGroup(group, type = 'pre') {
        if(type == 'pre')
          this.selectedSport.preMarketGroup.push(group.id);

        if(type == 'live')
          this.selectedSport.liveMarketGroup.push(group.id);
      },
      removeGroup(group, type = 'pre') {

        if(type == 'pre')
          var arry = this.selectedSport.preMarketGroup;

        if(type == 'live')
          var arry = this.selectedSport.liveMarketGroup;

        var filteredAry = arry.filter(e => e != group)

        if (filteredAry) {
          arry = filteredAry;

          if(type == 'pre')
            this.selectedSport.preMarketGroup = arry;

          if(type == 'live')
            this.selectedSport.liveMarketGroup = arry;
        }

      },
      preMoved (m) {

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/feed/sports/sports.vue